import { render, staticRenderFns } from "./ProductPrice.vue?vue&type=template&id=31e0f6ff&scoped=true&lang=pug&"
import script from "./ProductPrice.vue?vue&type=script&lang=ts&"
export * from "./ProductPrice.vue?vue&type=script&lang=ts&"
import style0 from "./ProductPrice.vue?vue&type=style&index=0&id=31e0f6ff&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e0f6ff",
  null
  
)

export default component.exports